import React from 'react';
import PageLoader from '../PageLoader/PageLoader';
import './ContextSwitchOverlay.scss';

export default function ContextSwitchOverlay({ active, message }) {
  if (!active) return null;

  return (
    <div
      className="context-switch-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={message}
    >
      <PageLoader tip={message} />
    </div>
  );
}
